import { render, staticRenderFns } from "./ControlPanelBlockAction.vue?vue&type=template&id=1dec0352&scoped=true&"
import script from "./ControlPanelBlockAction.vue?vue&type=script&lang=js&"
export * from "./ControlPanelBlockAction.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanelBlockAction.vue?vue&type=style&index=0&id=1dec0352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec0352",
  null
  
)

export default component.exports